import { useState } from 'react';

const ReadMoreContent = ({ text, maxLength }) => {
  const [isTruncated, setIsTruncated] = useState(true);

  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };

  const truncatedText = text.slice(0, maxLength);
  const hasTruncation = text.length > maxLength;

  return (
    <div>
      <span className='sub-para-1' dangerouslySetInnerHTML={{ __html: isTruncated ? truncatedText : text }}/>
        {hasTruncation && (
          <span className='text-red' onClick={toggleTruncate} style={{ cursor: 'pointer' }}>
            {isTruncated ? ' Read More' : ''}
          </span>
        )}
    </div>
  );
};

export default ReadMoreContent;
